import { environment } from '@environments/environment';

export const API_BASE_URL = environment.apiBaseUrl;

export const AUTH_ENDPOINTS = {
  login: `${API_BASE_URL}/auth/login`,
  me: `${API_BASE_URL}/auth/me`,
} as const;

export const UNIDADE_ENDPOINTS = {
  base: `${API_BASE_URL}/unidades`,
  byId: (id: number) => `${API_BASE_URL}/unidades/${id}`,
  ativar: (id: number) => `${API_BASE_URL}/unidades/${id}/ativar`,
  inativar: (id: number) => `${API_BASE_URL}/unidades/${id}/inativar`,
} as const;

export function isConfiguredApiUrl(url: string): boolean {
  if (url.startsWith(API_BASE_URL)) {
    return true;
  }

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return false;
  }

  const currentOrigin = globalThis.location?.origin;

  if (!currentOrigin) {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.origin === currentOrigin && parsedUrl.pathname.startsWith(API_BASE_URL);
  } catch {
    return false;
  }
}

export function isLoginUrl(url: string): boolean {
  return url === AUTH_ENDPOINTS.login || url.endsWith(AUTH_ENDPOINTS.login);
}
